<template>
  <div class="calendarboxpo" v-if="isshow">
      <Calendar
      v-on:choseDay="clickDay"
    ></Calendar>
    <div class="wrapbox" @click="wraphide">

    </div>
  </div>
</template>

<script>
import Calendar from 'vue-calendar-component'
// import moment from 'moment'
export default {
  data () {
    return {
      isshow: false,
      dqtype: 0
    }
  },
  methods: {
    show (type) {
      this.dqtype = type
      this.isshow = true
    },
    clickDay: function (data) {
      const that = this
      var dqdata = this.formatDate(new Date(data))
      if (this.dqtype === 1) {
        that.$emit('plandatastartfunc', dqdata)
      } else if (this.dqtype === 2) {
        that.$emit('plandataendfunc', dqdata)
      } else if (this.dqtype === 3) {
        that.$emit('datastartfunc', dqdata)
      } else if (this.dqtype === 4) {
        that.$emit('dataendfunc', dqdata)
      } else if (this.dqtype === 5) {
        that.$emit('estartfunc', dqdata)
      } else if (this.dqtype === 6) {
        that.$emit('eendfunc', dqdata)
      }
      this.isshow = false
    },
    hide: function () {
      this.isshow = false
    },
    wraphide: function () {
      this.isshow = false
    },
    formatDate: function (date) {
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      var d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      return y + '-' + m + '-' + d
    }
  },
  components: {
    Calendar
  }
}
</script>

<style scoped>
  .calendarboxpo{width: 300px;margin-top: 5px;}
  .wrapbox{width: 100%;height: 100%;position: fixed;top: 0;left: 0;z-index: 5;}
</style>



// WEBPACK FOOTER //
// src/components/calendar/calendar.vue